export class BankData {
  code: string;
  name: string;
  formattedName: string;

  constructor(bankData?: any) {
    if(bankData){
      this.code = bankData.code;
      this.name = bankData.name;
      this.formattedName = `${this.code} - ${this.name}`;
    }
  }
}
